import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { newJobPath } from "@/lib/ownerRoutes";

/**
 * The role-agnostic address of the job form.
 *
 * Every route in this app is namespaced by role — the form lives at
 * `/client/jobs/new` and at `/provider/requests/new`, and `ProtectedRoute`
 * bounces anyone who asks for the wrong half. That is fine for a signed-in
 * caller and impossible for an anonymous one: a visitor tapping "Invitar a
 * cotizar" on a FixyBee's page has no role yet, and the role they will have is
 * decided several screens later, in onboarding.
 *
 * So the `returnTo` a public CTA writes points here, and here resolves it once
 * there is an account to resolve it against. The query string rides through
 * untouched, which is the whole point: `?for=<slug>` is what makes the request
 * a directed one, and it is exactly what was being lost.
 *
 * Wrapped in `ProtectedRoute` at the mount, so an anonymous hit on this URL is
 * sent to sign in with its own `returnTo` rather than rendering nothing.
 */
export default function NewJobRoute() {
  const { user } = useAuth();
  const location = useLocation();
  return (
    <Navigate to={`${newJobPath(user?.profile?.role)}${location.search}`} replace />
  );
}
